<template>
    <section class="stack-chart">
        <canvas
            :id="uniqueId"
            :width="`${width}`"
            :height="`${height}`"
        />
    </section>
</template>

<script>
import Chart from 'chart.js'

export default {
	props: {
		type: {
			type: String,
			default: 'bar'
		},

		/* Visual Data */
		labels: {
			type: Array,
			default: () => [],
			required: true
		},

		data: {
			type: Array,
			default: () => [],
			required: true
		},

		/* Size */
		width: {
			type: Number,
			default: 300
		},

		height: {
			type: Number,
			default: 300
		}
	},

	data () {
		return {
			uniqueId: ''
		}
	},

	created () {
		this.generateUniqueId()
	},

	mounted () {
		this.initStackChart()
	},

	methods: {
		generateUniqueId () {
			this.uniqueId = Math.random().toString(36).substr(2, 9)
		},

		initStackChart () {
			const data = this.setData()
			const options = this.setOptions()

			Chart.defaults.global.defaultFontSize = 12

			Chart.defaults.global.defaultFontColor = '#4A4C50'

			const ctx = document.getElementById(this.uniqueId).getContext('2d')

			const stackChart = new Chart(ctx, {
				type: this.type,
				data: data,
				options: options
			})
		},

		setData () {
			const color = Chart.helpers.color

			return {
				labels: this.labels,

				datasets: [{
					backgroundColor: color('#6DDEFF').alpha(0.5).rgbString(),
					borderColor: '#54D8FF',
				    borderWidth: 2,
					data: this.data
				}]
			}
		},

		setOptions () {
			return {
				legend: {
					display: false
				},

				animation: {
					duration: 0
				},

				hover: {
					animationDuration: 0
				},

				responsiveAnimationDuration: 0,

				responsive: false,

				tooltips: {
					enabled: false
				},

				scales: {
					yAxes: [{
						display: true,

						ticks: {
							beginAtZero: true,

							suggestedMin: 1,

							suggestedMax: 5,

							callback: (label, index, labels) => {
								if (this.type === 'horizontalBar') return label

								if (Math.floor(label) === label) {
									return label
								}
							}
						},

						gridLines: {
							display: true
						}
					}],

					xAxes: [{
						display: true,

						ticks: {
							beginAtZero: true,

							suggestedMin: 1,

							suggestedMax: 5,

							callback: (label, index, labels) => {
								if (this.type === 'bar') return label

								if (Math.floor(label) === label) {
									return label
								}
							}
						},

						gridLines: {
							display: true
						}
					}]
				}
			}
		}
	}
}

</script>

<style lang="scss" scoped>
.stack-chart {
    width: 100%;
    height: 100%;

    canvas {
        width: 100%;
        height: 100%;
    }
}
</style>
